/**
 * Points of drawings are kept in time, so they stay on their candles when
 * older history comes and on another timeframe. Bar indexes are fractional
 * between bars; outside the stored bars they continue with the bar duration.
 */

/**
 * @param {number} time - ms
 * @param {object} store - BarStore
 * @param {number} barDurationMs
 * @returns {number|null} fractional bar index; null when there are no bars
 */
export const timeToIndex = (time, { bars }, barDurationMs) => {
  if (!bars.length) return null;

  const lastIndex = bars.length - 1;

  if (time <= bars[0].time) return (time - bars[0].time) / barDurationMs;
  if (time >= bars[lastIndex].time) return lastIndex + (time - bars[lastIndex].time) / barDurationMs;

  let low = 0;
  let high = lastIndex;

  while (high - low > 1) {
    const middle = Math.floor((low + high) / 2);

    if (bars[middle].time <= time) low = middle;
    else high = middle;
  }

  return low + (time - bars[low].time) / (bars[high].time - bars[low].time);
};

/**
 * @param {number} index - fractional bar index
 * @param {object} store - BarStore
 * @param {number} barDurationMs
 * @returns {number|null} ms; null when there are no bars
 */
export const indexToTime = (index, { bars }, barDurationMs) => {
  if (!bars.length) return null;

  const lastIndex = bars.length - 1;

  if (index <= 0) return bars[0].time + index * barDurationMs;
  if (index >= lastIndex) return bars[lastIndex].time + (index - lastIndex) * barDurationMs;

  const low = Math.floor(index);

  return bars[low].time + (index - low) * (bars[low + 1].time - bars[low].time);
};
